var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchingfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6846EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E063FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16318 4.16002C8.16318 3.48615 8.94735 3.11621 9.46741 3.54473L13.5632 6.91952C14.2173 7.45853 14.2156 8.46101 13.5596 8.99776L9.46528 12.3476C8.94473 12.7735 8.16317 12.4032 8.16317 11.7306V10.1007C7.55204 10.0529 6.66729 10.1079 5.8705 10.3972C4.97908 10.7209 4.23595 11.3201 4.05444 12.3659C4.02101 12.5585 3.87248 12.6825 3.71954 12.718C3.56108 12.7547 3.35775 12.702 3.26027 12.5046C2.50297 10.9708 2.59514 9.28611 3.4936 7.98282C4.36038 6.7255 5.95152 5.85885 8.16318 5.79817V4.16002ZM14.5326 20.3605C15.0527 20.789 15.8368 20.4191 15.8368 19.7452V18.1071C18.0485 18.0464 19.6396 17.1797 20.5064 15.9224C21.4049 14.6191 21.497 12.9344 20.7397 11.4007C20.6423 11.2032 20.4389 11.1505 20.2805 11.1873C20.1275 11.2228 19.979 11.3467 19.9456 11.5393C19.764 12.5851 19.0209 13.1844 18.1295 13.508C17.3327 13.7974 16.448 13.8523 15.8368 13.8045V12.1746C15.8368 11.5021 15.0553 11.1317 14.5347 11.5576L10.4404 14.9075C9.78441 15.4442 9.78268 16.4467 10.4368 16.9857L14.5326 20.3605Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingfill);
export default __webpack_public_path__ + "static/media/matching.fill.c6b6990287c7427c5bb0a7c862942639.svg";
export { ForwardRef as ReactComponent };